import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ModalDialog } from 'bookingform';
import MinimumStaysCalendar from '../hotels/MinimumStaysCalendar';

class FreeModeMinStays extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMinStays: false,
    };
  }

  toggleMinStays = () => {
    this.setState({ showMinStays: !this.state.showMinStays });
  };

  renderNew(requestedInfo) {
    return (
      <MinimumStaysCalendar
        omitRestrictions={false}
        hotelCode={requestedInfo.hotels[0]}
        checkIn={requestedInfo.checkIn}
      />
    );
  }

  renderMinStays(requestedInfo) {
    const dialogProps = {
      actions: [],
      bodyElement: this.renderNew(requestedInfo),
      clickHandler: () => this.toggleMinStays(),
    };
    return (
      <ModalDialog isVisible {...dialogProps} />
    );
  }

  renderButton() {
    return (
      <button className="btn btn-lg btn-primary mt-4 px-4 py-2 show-calendar" onClick={this.toggleMinStays}>
        {this.context.t('Show Calendar')}
      </button>
    );
  }

  render() {
    const { lastRequestedInfo } = this.props;
    return (
      <div className="FreeModeMinStays">
        {this.state.showMinStays && this.renderMinStays(lastRequestedInfo)}
        {!this.state.showMinStays && this.renderButton()}
      </div>
    );
  }
}

FreeModeMinStays.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect((state) => ({
  lastRequestedInfo: state.booking.last_requested_info,
}))(FreeModeMinStays);
